import { NewPlpTypes } from 'lib/apis/services/NewPlpListiing';
import { observer } from 'mobx-react';
import { ArrayNumber, Range } from '../filterFields';
import Integer from '../filterFields/integer';
import OneSelected from '../filterFields/oneSelected';

const RenderFields = ({ item }: { item: NewPlpTypes.SemanticFilterItems }) => {
  switch (item.type) {
    case 'ONE_SELECTED':
      return (
        <OneSelected
          name={item.fieldName}
          data={item.values as NewPlpTypes.ArrayNumberFilterValueType[]}
          titleKey="name"
          valueKey="id"
        />
      );
    case 'ArrayNumber':
      return (
        <ArrayNumber
          name={item.fieldName}
          data={item.values as NewPlpTypes.ArrayNumberFilterValueType[]}
          titleKey="name"
          valueKey="id"
        />
      );
    case 'RANGE':
      return (
        <Range
          data={item.values as NewPlpTypes.RangeFilterValueType}
          name={item.fieldName}
          label={{
            min: `حداقل ${item.title}`,
            max: `حداکثر ${item.title}`,
          }}
        />
      );
    default:
      return (
        <Integer
          name={item.fieldName}
          data={(item.values as NewPlpTypes.RangeFilterValueType).minValues}
        />
      );
  }
};

export default observer(RenderFields);
